import React from 'react';
import { Link } from 'react-router-dom';

/**
 * A wrapper component around React Router's Link that ensures
 * the page scrolls to the top after navigation.
 */
const ScrollToTopLink = ({ children, to, className, ...props }) => {
  const handleClick = () => {
    // Force immediate scroll to top
    window.scrollTo(0, 0);
    
    // Also try with a small delay to ensure it works after rendering
    setTimeout(() => {
      window.scrollTo(0, 0);
      
      // Try alternative methods as well
      if (document.body) {
        document.body.scrollTop = 0;
      }
      
      if (document.documentElement) {
        document.documentElement.scrollTop = 0;
      }
    }, 0);
  };

  return (
    <Link 
      to={to} 
      className={className} 
      onClick={handleClick} 
      {...props}
    >
      {children}
    </Link>
  );
};

export default ScrollToTopLink; 